"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pink = exports.cyan = exports.coral = exports.blue = exports.red = exports.orange = exports.grey = exports.divider = exports.text = exports.info = exports.warning = exports.error = exports.success = exports.primary = exports.secondary = exports.common = exports.green = exports.purple = void 0;
const grey_1 = __importDefault(require("@mui/material/colors/grey"));
const purple = {
    50: '#F0ECFB',
    100: '#d6caf2',
    200: '#bba6eb',
    300: '#a081e3',
    400: '#8964DC',
    500: '#7449d5',
    600: '#6a43ce',
    700: '#5c3bc5',
    800: '#4e34bd',
    900: '#3929af',
};
exports.purple = purple;
const green = {
    50: '#e6f6ed',
    100: '#c2e7d4',
    200: '#9bd8b8',
    300: '#70ca9d',
    400: '#4dbe88',
    500: '#1ab373',
    600: '#13a468',
    700: '#07915b',
    800: '#00804f',
    900: '#006139'
};
exports.green = green;
const blue = {
    50: '#e2f1ff',
    100: '#b9dcff',
    200: '#8bc6ff',
    300: '#59b0ff',
    400: '#2f9fff',
    500: '#008eff',
    600: '#0380f2',
    700: '#0e6ede',
    800: '#125ccc',
    900: '#153dad'
};
exports.blue = blue;
const orange = {
    10: '#fefaed',
    50: '#fbebe8',
    100: '#ffd1be',
    200: '#ffb495',
    300: '#ff9769',
    400: '#ff8147',
    500: '#ff6e25',
    600: '#f46721',
    700: '#e6601c',
    800: '#d85919',
    900: '#c04c11',
    1000: '#f9ce46',
    1100: '#c7a538',
};
exports.orange = orange;
const red = {
    50: '#ffedf0',
    100: '#ffd3d7',
    200: '#f4a3a3',
    300: '#ec807f',
    400: '#f8655e',
    500: '#ff5947',
    600: '#ef5045',
    700: '#dd463e',
    800: '#d04038',
    900: '#c0372c',
};
exports.red = red;
const grey = Object.assign(Object.assign({}, grey_1.default), { 50: '#f4f7f9', 100: '#ebf0f4', 200: '#dae2eb', 300: '#c3d0de', 400: '#aab9cf', 500: '#94a3c0', 600: '#7d89ae', 700: '#757f9f', 800: '#58617b', 900: '#4b5264', A700: '#9C9EA7' });
exports.grey = grey;
const common = {
    black: '#000',
    white: '#fff'
};
exports.common = common;
const secondary = {
    main: '#475480',
};
exports.secondary = secondary;
const primary = {
    main: purple[600],
};
exports.primary = primary;
const success = {
    main: green[500],
};
exports.success = success;
const error = {
    main: '#F61809',
};
exports.error = error;
const warning = {
    main: '#F9CE46',
};
exports.warning = warning;
const info = {
    main: '#125DCC',
};
exports.info = info;
const text = {
    primary: '#475480',
    secondary: '#757F9F',
    disabled: '#D2D5E0',
};
exports.text = text;
const divider = '#EDEEF2';
exports.divider = divider;
const coral = {
    50: '#fbebe8',
    100: '#ffd1be',
    200: '#ffb495',
    300: '#ff9769',
    400: '#ff8147',
    500: '#ff6e25',
    600: '#f46721',
    700: '#e6601c',
    800: '#d85919',
    900: '#c04c11',
    1000: '#f61809',
};
exports.coral = coral;
const cyan = {
    50: '#e1f7fd',
    100: '#b5ebf8',
    200: '#84dff4',
    300: '#55d1ed',
    400: '#35c7e7',
    500: '#26bee0',
    600: '#21aecd',
    700: '#1999b2',
    800: '#138599',
    900: '#07626d',
    1000: '#138699',
    1100: '#4CE6FF',
    1200: '#e9fcff',
    1300: '#19b3cc',
    1400: '#5791ea',
};
exports.cyan = cyan;
const pink = {
    50: '#fce7ef',
    100: '#f8c2d9',
    200: '#f69cc0',
    300: '#f476a6',
    400: '#f25c92',
    500: '#f3467e',
    600: '#e14279',
    700: '#ca3d72',
    800: '#b4396d',
    900: '#8e3061'
};
exports.pink = pink;
